export default "__VITE_PUBLIC_ASSET__c8bde0c5__"